// Generated by purs version 0.14.3
"use strict";
var Data_Int = require("../Data.Int/index.js");
var Inc = {};
var IncP = {};
var IncD = {};
var DProxy = (function () {
    function DProxy() {

    };
    DProxy.value = new DProxy();
    return DProxy;
})();
var KnownDigit = function (digitVal) {
    this.digitVal = digitVal;
};
var DLProxy = (function () {
    function DLProxy() {

    };
    DLProxy.value = new DLProxy();
    return DLProxy;
})();
var DigitCount = function (digitCount) {
    this.digitCount = digitCount;
};
var KnownSize = function (sizeVal) {
    this.sizeVal = sizeVal;
};
var IntSize = function (KnownSize0) {
    this.KnownSize0 = KnownSize0;
};
var ByteSize = function (KnownSize0) {
    this.KnownSize0 = KnownSize0;
};
var sizeVal = function (dict) {
    return dict.sizeVal;
};
var sizeN9 = new KnownDigit(function (v) {
    return 9;
});
var sizeN8 = new KnownDigit(function (v) {
    return 8;
});
var sizeN7 = new KnownDigit(function (v) {
    return 7;
});
var sizeN6 = new KnownDigit(function (v) {
    return 6;
});
var sizeN5 = new KnownDigit(function (v) {
    return 5;
});
var sizeN4 = new KnownDigit(function (v) {
    return 4;
});
var sizeN3 = new KnownDigit(function (v) {
    return 3;
});
var sizeN2 = new KnownDigit(function (v) {
    return 2;
});
var sizeD1 = new KnownDigit(function (v) {
    return 1;
});
var sizeD0 = new KnownDigit(function (v) {
    return 0;
});
var incPNil1 = function (dictIncD) {
    return IncP;
};
var incPLoop1 = function (dictIncP) {
    return function (dictIncD) {
        return function (dictIf) {
            return function (dictIf1) {
                return IncP;
            };
        };
    };
};
var incD9 = IncD;
var incD8 = IncD;
var incD7 = IncD;
var incD6 = IncD;
var incD5 = IncD;
var incD4 = IncD;
var incD3 = IncD;
var incD2 = IncD;
var incD1 = IncD;
var incD0 = IncD;
var inc = function (dictIncP) {
    return function (dictIf) {
        return Inc;
    };
};
var digitVal = function (dict) {
    return dict.digitVal;
};
var knownSizeBase = function (dictKnownDigit) {
    return new KnownSize(function (p) {
        return digitVal(dictKnownDigit)(DProxy.value);
    });
};
var intSize8 = new IntSize(function () {
    return knownSizeBase(sizeN8);
});
var digitCount = function (dict) {
    return dict.digitCount;
};
var knownSizeLoop = function (dictDigitCount) {
    return function (dictKnownSize) {
        return function (dictKnownDigit) {
            return new KnownSize(function (v) {
                var currentPow = digitCount(dictDigitCount)(DLProxy.value);
                var head = Data_Int.pow(10)(currentPow) * digitVal(dictKnownDigit)(DProxy.value) | 0;
                return head + sizeVal(dictKnownSize)(DLProxy.value) | 0;
            });
        };
    };
};
var countLoop = function (dictDigitCount) {
    return new DigitCount(function (v) {
        return digitCount(dictDigitCount)(DLProxy.value) + 1 | 0;
    });
};
var countBase = new DigitCount(function (v) {
    return 1;
});
var intSize104 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeD0))(sizeD1);
});
var intSize112 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeD1))(sizeD1);
});
var intSize120 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN2))(sizeD1);
});
var intSize128 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN2))(sizeD1);
});
var intSize136 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN3))(sizeD1);
});
var intSize144 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN4))(sizeD1);
});
var intSize152 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN5))(sizeD1);
});
var intSize16 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeD1);
});
var intSize160 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN6))(sizeD1);
});
var intSize168 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN6))(sizeD1);
});
var intSize176 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN7))(sizeD1);
});
var intSize184 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN8))(sizeD1);
});
var intSize192 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN9))(sizeD1);
});
var intSize200 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeD0))(sizeN2);
});
var intSize208 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeD0))(sizeN2);
});
var intSize216 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeD1))(sizeN2);
});
var intSize224 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN2))(sizeN2);
});
var intSize232 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN3))(sizeN2);
});
var intSize24 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN2);
});
var intSize240 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN4))(sizeN2);
});
var intSize248 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN4))(sizeN2);
});
var intSize256 = new IntSize(function () {
    return knownSizeLoop(countLoop(countBase))(knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN5))(sizeN2);
});
var intSize32 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN3);
});
var intSize40 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN4);
});
var intSize48 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN4);
});
var intSize56 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN5);
});
var intSize64 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN6);
});
var intSize72 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN7);
});
var intSize80 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN8);
});
var intSize88 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN8);
});
var intSize96 = new IntSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN9);
});
var byteSize9 = new ByteSize(function () {
    return knownSizeBase(sizeN9);
});
var byteSize8 = new ByteSize(function () {
    return knownSizeBase(sizeN8);
});
var byteSize7 = new ByteSize(function () {
    return knownSizeBase(sizeN7);
});
var byteSize6 = new ByteSize(function () {
    return knownSizeBase(sizeN6);
});
var byteSize5 = new ByteSize(function () {
    return knownSizeBase(sizeN5);
});
var byteSize4 = new ByteSize(function () {
    return knownSizeBase(sizeN4);
});
var byteSize32 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN3);
});
var byteSize31 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD1))(sizeN3);
});
var byteSize30 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN3);
});
var byteSize3 = new ByteSize(function () {
    return knownSizeBase(sizeN3);
});
var byteSize29 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN9))(sizeN2);
});
var byteSize28 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeN2);
});
var byteSize27 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN7))(sizeN2);
});
var byteSize26 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeN2);
});
var byteSize25 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN5))(sizeN2);
});
var byteSize24 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeN2);
});
var byteSize23 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN3))(sizeN2);
});
var byteSize22 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeN2);
});
var byteSize21 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD1))(sizeN2);
});
var byteSize20 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeN2);
});
var byteSize2 = new ByteSize(function () {
    return knownSizeBase(sizeN2);
});
var byteSize19 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN9))(sizeD1);
});
var byteSize18 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN8))(sizeD1);
});
var byteSize17 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN7))(sizeD1);
});
var byteSize16 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN6))(sizeD1);
});
var byteSize15 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN5))(sizeD1);
});
var byteSize14 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN4))(sizeD1);
});
var byteSize13 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN3))(sizeD1);
});
var byteSize12 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeN2))(sizeD1);
});
var byteSize11 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD1))(sizeD1);
});
var byteSize10 = new ByteSize(function () {
    return knownSizeLoop(countBase)(knownSizeBase(sizeD0))(sizeD1);
});
var byteSize1 = new ByteSize(function () {
    return knownSizeBase(sizeD1);
});
module.exports = {
    KnownSize: KnownSize,
    sizeVal: sizeVal,
    DLProxy: DLProxy,
    IntSize: IntSize,
    ByteSize: ByteSize,
    Inc: Inc,
    DProxy: DProxy,
    IncP: IncP,
    IncD: IncD,
    KnownDigit: KnownDigit,
    digitVal: digitVal,
    DigitCount: DigitCount,
    digitCount: digitCount,
    countBase: countBase,
    countLoop: countLoop,
    sizeD0: sizeD0,
    sizeD1: sizeD1,
    sizeN2: sizeN2,
    sizeN3: sizeN3,
    sizeN4: sizeN4,
    sizeN5: sizeN5,
    sizeN6: sizeN6,
    sizeN7: sizeN7,
    sizeN8: sizeN8,
    sizeN9: sizeN9,
    knownSizeBase: knownSizeBase,
    knownSizeLoop: knownSizeLoop,
    incD0: incD0,
    incD1: incD1,
    incD2: incD2,
    incD3: incD3,
    incD4: incD4,
    incD5: incD5,
    incD6: incD6,
    incD7: incD7,
    incD8: incD8,
    incD9: incD9,
    inc: inc,
    incPNil1: incPNil1,
    incPLoop1: incPLoop1,
    intSize8: intSize8,
    intSize16: intSize16,
    intSize24: intSize24,
    intSize32: intSize32,
    intSize40: intSize40,
    intSize48: intSize48,
    intSize56: intSize56,
    intSize64: intSize64,
    intSize72: intSize72,
    intSize80: intSize80,
    intSize88: intSize88,
    intSize96: intSize96,
    intSize104: intSize104,
    intSize112: intSize112,
    intSize120: intSize120,
    intSize128: intSize128,
    intSize136: intSize136,
    intSize144: intSize144,
    intSize152: intSize152,
    intSize160: intSize160,
    intSize168: intSize168,
    intSize176: intSize176,
    intSize184: intSize184,
    intSize192: intSize192,
    intSize200: intSize200,
    intSize208: intSize208,
    intSize216: intSize216,
    intSize224: intSize224,
    intSize232: intSize232,
    intSize240: intSize240,
    intSize248: intSize248,
    intSize256: intSize256,
    byteSize1: byteSize1,
    byteSize2: byteSize2,
    byteSize3: byteSize3,
    byteSize4: byteSize4,
    byteSize5: byteSize5,
    byteSize6: byteSize6,
    byteSize7: byteSize7,
    byteSize8: byteSize8,
    byteSize9: byteSize9,
    byteSize10: byteSize10,
    byteSize11: byteSize11,
    byteSize12: byteSize12,
    byteSize13: byteSize13,
    byteSize14: byteSize14,
    byteSize15: byteSize15,
    byteSize16: byteSize16,
    byteSize17: byteSize17,
    byteSize18: byteSize18,
    byteSize19: byteSize19,
    byteSize20: byteSize20,
    byteSize21: byteSize21,
    byteSize22: byteSize22,
    byteSize23: byteSize23,
    byteSize24: byteSize24,
    byteSize25: byteSize25,
    byteSize26: byteSize26,
    byteSize27: byteSize27,
    byteSize28: byteSize28,
    byteSize29: byteSize29,
    byteSize30: byteSize30,
    byteSize31: byteSize31,
    byteSize32: byteSize32
};
